@if (mapItem() && (visibleMeasureGroups$ | async); as visibleMeasureGroups) {
    @if (visibleMeasureGroups.length) {
        <div
            class="measures"
            [class.measures--slim]="isInPopup"
        >
            @for (measureGroup of visibleMeasureGroups; track $index) {
                <div
                    class="measures__group"
                >
                    <ui-detail-tags
                        [tags]="[measureGroup.status]"
                    />
                    <ul
                        class="measures__measures"
                    >
                        @for (measure of measureGroup.measures; track $index) {
                            <ui-detail-description
                                [htmlDescription]="
                        measureGroup.measures.length > 1
                        ? '<li>' + measure.description + '</li>'
                        : measure.description
                    "
                            />
                        }
                    </ul>
                </div>
            }
        </div>
    }
}
